import { Box, Image } from '@zillow/constellation-10';

import { shimmerStyles } from '../styles/ShimmerStyles';

import type { ImagePropsInterface } from '@zillow/constellation-10';

export const LoadingImage = ({
  isLoading,
  loadingWidth,
  loadingHeight,
  css: cssProp,
  style: styleProp,
  ...rest
}: {
  isLoading: boolean;
  loadingWidth: string;
  loadingHeight: string;
} & Omit<ImagePropsInterface, 'ref'>) => (
  <>
    {isLoading ? (
      <Box
        data-loading={true}
        css={{ ...cssProp, ...shimmerStyles }}
        style={{ width: loadingWidth, height: loadingHeight, ...styleProp }}
      />
    ) : (
      <Image css={{ ...cssProp, ...(isLoading ? { display: 'none' } : {}) }} {...rest} />
    )}
  </>
);
